import React from "react";
import { Box, Typography, Button, alpha, useTheme } from "@mui/material";

const EmptyState = ({
  icon: Icon,
  title,
  description,
  action,
  actionLabel,
}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 8,
        px: 3,
        textAlign: "center",
      }}
    >
      {Icon && (
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: "50%",
            mb: 2.5,
            background: alpha(theme.palette.primary.main, 0.08),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Icon
            sx={{ fontSize: 40, color: alpha(theme.palette.primary.main, 0.5) }}
          />
        </Box>
      )}
      <Typography
        variant="h6"
        fontWeight={700}
        gutterBottom
        color="text.primary"
      >
        {title}
      </Typography>
      {description && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ maxWidth: 360, mb: 3 }}
        >
          {description}
        </Typography>
      )}
      {action && (
        <Button variant="contained" onClick={action} sx={{ borderRadius: 2 }}>
          {actionLabel}
        </Button>
      )}
    </Box>
  );
};

export default EmptyState;
